import { IKeyObjective } from 'legacy/lut/classes/models/partner360/IFormOptionsJBP'
import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'

import { TKeyInitiative } from 'partner360/entities/keyInitiatives'

export interface IKeyObjectiveOption {
  key: string
  label: string
}

interface ITransformKeyObjectivesToOptions {
  programType: ProgramTypes
  keyObjectives: IKeyObjective[]
  data: TKeyInitiative[]
}

export const transformKeyObjectivesToOptions = ({
  programType,
  keyObjectives,
  data,
}: ITransformKeyObjectivesToOptions): IKeyObjectiveOption[] => {
  const availableDevelopments = Array.from(
    new Set(data.map((item) => item.Development).filter((value): value is string => Boolean(value)))
  )

  const getBreadcrumb = (objective: IKeyObjective): string => {
    if (!objective.parent) {
      return objective.key
    }

    const parent = keyObjectives.find((item) => item.key === objective.parent)

    return parent ? `${getBreadcrumb(parent)} → ${objective.key}` : objective.key
  }

  const optionsFromDictionary = keyObjectives
    .filter((objective) => !objective.offerings || objective.offerings.includes(programType))
    .filter((objective) => availableDevelopments.includes(objective.key))
    .map((objective) => ({
      key: objective.key,
      label: getBreadcrumb(objective),
    }))

  const dictionaryKeys = new Set(optionsFromDictionary.map((option) => option.key))

  const fallbackOptions = availableDevelopments
    .filter((development) => !dictionaryKeys.has(development))
    .map((development) => ({
      key: development,
      label: development,
    }))

  return [...optionsFromDictionary, ...fallbackOptions].sort((a, b) =>
    a.label.localeCompare(b.label)
  )
}
